import { RoofIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import { BuildingSectionProps, roofFieldValues } from "../BuildingConstruction.constants";
import BuildingSectionBody from "./BuildingSectionBody";

function BuildingRoof(props: BuildingSectionProps) {
    return (
        <>
            <div className="construction-sidebar__body__header">
                <RoofIcon />
                <Header size="medium">Roof</Header>
            </div>
            <BuildingSectionBody {...props} fields={roofFieldValues} />
        </>
    );
}

export default BuildingRoof;
